import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromLocations from './locations.reducer';
import { LocationsEffects } from './locations.effects';
import { LocationsFacade } from './locations.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromLocations.LOCATIONS_FEATURE_KEY,
      fromLocations.reducer
    ),
    EffectsModule.forFeature([LocationsEffects]),
  ],
  providers: [LocationsFacade],
})
export class LocationsStateModule {}
